
import React, { Component } from 'react';

import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';

export default class Download extends Component {

  render = () =>
    <Typography component="div" style={{ padding: 8 * 3 }}>
      STMC is released under the <Link href='https://www.gnu.org/licenses/gpl-3.0.en.html' target='_blank' rel='noreferrer'>GNU General Public License v3.0</Link> and 
      is hosted on <Link href='https://github.com/nima-roohi/STMC' target='_blank' rel='noreferrer'>GitHub</Link>, where installation instructions, as well as how to 
      run benchmarks and other examples, can be found.
    </Typography>
}